import React, { Component, Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import { Nav, Navbar, NavItem } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import "./App.css";
import Routes from "./Routes";
import { Auth, API } from "aws-amplify";






class App extends Component {
  constructor(props) {
  super(props);
  this.state = {
    isAuthenticated: false,
    isAuthenticating: true,
    cognitoId:""
  };
}
handleLogout = async event => {
  await Auth.signOut();

  this.userHasAuthenticated(false);

  this.props.history.push("/login");
}
userHasAuthenticated = authenticated => {
  this.setState({ isAuthenticated: authenticated });
  if(authenticated===true){
    console.log("Attempting API")
    Auth.currentCredentials().then((info) => {
        const cognitoIdentityId = info.data.IdentityId;
        console.log(info)
        console.log(cognitoIdentityId)
        this.setState({cognitoId:cognitoIdentityId})
    });
  }



}


apitest=async event=>{

  //await this.createNote({
       //content: "hello world"
     //});

}

getdata(note) {
  return API.get("AltiomData", "/welcome");
}

async componentDidMount() {
  try {
    console.log("Component did mount")
    console.log(this.props.location.search)
    if (await Auth.currentSession()) {
      this.userHasAuthenticated(true);

  //    const data = await this.getdata();
  //    this.setState({
  //    "data":data.data
  //  });
    }
  }
  catch(e) {
    console.log(e)
    if (e !== 'No current user') {
      console.log(e)
    //  alert(e);
    }
  }

  this.setState({ isAuthenticating: false });




}
render() {
  const childProps = {
    isAuthenticated: this.state.isAuthenticated,
    userHasAuthenticated: this.userHasAuthenticated,
    userid:this.state.cognitoId
  };




  return (
    !this.state.isAuthenticating &&
    <div className="App container">
    <Navbar fluid collapseOnSelect>
  <Navbar.Header>
    <Navbar.Brand>
      <Link to="/">ALTIOM</Link>
    </Navbar.Brand>
    <Navbar.Toggle />
  </Navbar.Header>
  <Navbar.Collapse>
    <Nav pullRight>
      {this.state.isAuthenticated
        ? <Fragment>
            <LinkContainer to="/settings">
              <NavItem>Settings</NavItem>
            </LinkContainer>
            <NavItem onClick={this.handleLogout}>Logout</NavItem>
          </Fragment>
        : <Fragment>
            <LinkContainer to={"/signup"+this.props.location.search}>
              <NavItem>Signup</NavItem>
            </LinkContainer>
            <LinkContainer to={"/login"+this.props.location.search}>
              <NavItem>Login</NavItem>
            </LinkContainer>
          </Fragment>
      }
    </Nav>
  </Navbar.Collapse>
</Navbar>
      <Routes childProps={childProps} auth={this.state.isAuthenticated} />
    </div>
  );
}

}


export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js